<template>
  <v-dialog
    v-model="dialog"
    width="500"
    :disabled="$attrs.disabled || loading"
  >
    <template v-slot:activator="{ on }">
      <v-btn :color="color"
             v-bind="$attrs"
             :loading="loading"
             :text="text"
             v-on="on"
      >
        <slot>
          {{ $t('Delete') }}
        </slot>
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="title secondary--text"
      >
        <slot name="title">
          {{ $t('Are you sure?') }}
        </slot>
      </v-card-title>
      <v-card-title class="body-2">
        <slot name="body">
          {{ $t('This will be permanent') }}
        </slot>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <cancel-button @click="onCancel"
                       :loading="loading"
        >

        </cancel-button>
        <primary-button @click="onSubmit"
                        color="error"
                        :loading="loading"
        >
          {{ confirmText }}
        </primary-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>

<script>
  import CancelButton from './CancelButton';
  import PrimaryButton from './PrimaryButton';

  export default {
    name: 'ConfirmButton',
    inheritAttrs: false,
    props: {
      loading: {
        type: Boolean,
        default() {
          return false;
        },
      },
      confirmText: {
        type: String,
        default() {
          return this.$t('Delete');
        },
      },
      text: {
        type: Boolean,
        default() {
          return true;
        },
      },
    },
    data() {
      return {
        dialog: false,
      };
    },
    computed: {
      color() {
        return this.$attrs.color || 'warning';
      }
    },
    methods: {
      onCancel() {
        this.dialog = false;
      },
      onSubmit() {
        this.$emit('click');
        this.dialog = false;
      },
      show() {
        this.dialog = true;
      },
      hide() {
        this.dialog = false;
      },
    },
    components: {
      CancelButton,
      PrimaryButton,
    },
  };
</script>

